import moment from 'moment';

export default {
    install: function (Vue, options) {
        Vue.prototype.$helpers = new Vue({
            methods: {
                isset: function(obj, props) {
                    if (typeof props === 'string') {
                        props = props.split('.');
                    }
                    if (typeof obj === 'undefined') {
                        return false;
                    } else if (props && props.length > 0) {
                        if (obj === null) {
                            return false;
                        }
                        return this.isset(obj[props.shift()], props);
                    }
                    return true;
                },

                isSubscribed: function(company) {
                    company = this.getCompany(company);

                    if (this.isset(company, 'subscription.subscribed')) {
                        return !!company.subscription.subscribed;
                    }
                    return true;
                },

                trialDaysLeft: function(company) {
                    company = this.getCompany(company);

                    if (this.isset(company, 'subscription.subscribed')) {
                        var subscription = company.subscription;

                        if (subscription.trial_ends_at) {
                            var now = moment();
                            var date = moment.utc(subscription.trial_ends_at);

                            if (date.diff(now) < 0) {
                                return 0;
                            }
                            return Math.ceil(date.diff(now, 'days', true) || 1);
                        }
                    }
                    return null;
                },

                trialEnded: function(company) {
                    company = this.getCompany(company);

                    if (this.isset(company, 'subscription.subscribed')) {
                        var subscription = company.subscription;

                        if (subscription.subscribed) {
                            return false;
                        }
                        if (subscription.trial_ends_at) {
                            var now = moment();
                            var date = moment.utc(subscription.trial_ends_at);

                            return date.diff(now) < 0;
                        }
                    }
                    return null;
                },

                isOnGracePeriod: function(company) {
                    company = this.getCompany(company);

                    if (this.isset(company, 'subscription.on_grace_period')) {
                        return !!company.subscription.on_grace_period;
                    }
                    return null;
                },

                graceDaysLeft: function(company) {
                    company = this.getCompany(company);

                    if (this.isOnGracePeriod(company) && this.isset(company, 'subscription.grace_period_ends_at')) {
                        var subscription = company.subscription;

                        if (subscription.grace_period_ends_at) {
                            var now = moment();
                            var date = moment.utc(subscription.grace_period_ends_at);

                            if (date.diff(now) < 0) {
                                return 0;
                            }
                            return Math.ceil(date.diff(now, 'days', true) || 1);
                        }
                    }
                    return null;
                },

                subscriptionEnded: function(company) {
                    company = this.getCompany(company);

                    if (this.isset(company, 'subscription.grace_period_ends_at')) {
                        var subscription = company.subscription;

                        if (subscription.grace_period_ends_at) {
                            var now = moment();
                            var date = moment.utc(subscription.grace_period_ends_at);

                            return date.diff(now) < 0;
                        }
                    }
                    return null;
                },

              trialPeriodText: function(company, subscribe) {
                    company = this.getCompany(company);

                    subscribe = typeof subscribe === 'undefined' ? true : !!subscribe;

                    var subscribeText = subscribe ? ' Click here to subscribe!' : '';
                    var daysLeft = this.$helpers.trialDaysLeft(company);

                    if (daysLeft < 1) {
                        return 'Your trial period has ended.' + subscribeText;
                    }
                    if (daysLeft == 1) {
                        return 'You have 1 day left on your trial period.' + subscribeText;
                    }
                    return 'You have ' + daysLeft + ' day left on your trial period.' + subscribeText;
                },

                gracePeriodText: function(company, subscribe) {
                    company = this.getCompany(company);

                    subscribe = typeof subscribe === 'undefined' ? true : !!subscribe;

                    var subscribeText = subscribe ? ' Click here to subscribe!' : '';
                    var daysLeft = this.$helpers.trialDaysLeft(company);

                    if (daysLeft < 1) {
                        return 'Your grace period has ended.' + subscribeText;
                    }
                    if (daysLeft == 1) {
                        return 'You have 1 day left on your grace period.' + subscribeText;
                    }
                    return 'You have ' + daysLeft + ' day left on your grace period.' + subscribeText;
                },

                getCompany: function(company) {
                    if (this.isset(company, 'subscribed')) {
                        return { subscription: company };
                    }
                    return company;
                }
            }
        });
    }
};
